export function getLsObject(key, defaultValue) {
  var result = defaultValue;
  if (globalThis.localStorage) {
    try {
      var value = globalThis.localStorage.getItem(key);
      if (value) {
        result = JSON.parse(value);
      }
    } catch (e) {
      console.error('[LS getObject]', e);
    }
  }
  return result;
}
export function removeLsObject(key) {
  if (globalThis.localStorage) {
    globalThis.localStorage.removeItem(key);
  }
}
export function setLsObject(key, value) {
  if (globalThis.localStorage) {
    globalThis.localStorage.setItem(key, JSON.stringify(value));
  }
}